export default __webpack_public_path__ + "static/media/evalution.8ade5873.png";